<template>

  <div>
    <PageTitle
      :route="$route"
    />

    <PageRowWrapper>
      <CommandTypeForm />
    </PageRowWrapper>
  </div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import CommandTypeForm from '@/components/settings/parameters/commandTypes/CommandTypeForm'

export default {
  name: 'CommandType',
  components: {
    PageTitle,
    PageRowWrapper,
    CommandTypeForm
  }
}
</script>
